import React from "react";
import { Cat, Crumbs, PageHeader, Panel, StatTiles } from "../ui/AdminUi";
import ImpersonationPanel from "./ImpersonationPanel";
import { fmtNumber, programStyle } from "./tenantModel";

/** One training center opened: its facts, the support contact, and the impersonation tool. */
export default function TenantWorkspace({ tenant, impersonating, onBack, onImpersonate, onExit }) {
  return (
    <>
      <PageHeader
        crumbs={<Crumbs trail={[{ label: "Tenant switcher", onClick: onBack }, { label: tenant.name }]} />}
        title={tenant.name}
        desc={(
          <span style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
            <span className="mono">{tenant.code}</span>
            <Cat c={programStyle(tenant.program).label} />
          </span>
        )}
      />

      <StatTiles items={[
        { label: "Active courses", value: fmtNumber(tenant.courses) },
        { label: "Students", value: fmtNumber(tenant.students) },
        { label: "Instructors", value: fmtNumber(tenant.instructors) },
      ]} />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(min(360px,100%),1fr))", gap: 16, alignItems: "start" }}>
        {!impersonating && (
          <Panel title="Support and admin">
            <dl className="dl" style={{ padding: "4px 18px 8px" }}>
              <dt>Support contact</dt>
              <dd>
                {tenant.support
                  ? <a className="ga-link mono" style={{ fontSize: 13 }} href={`mailto:${tenant.support}`}>{tenant.support}</a>
                  : <span className="sub">Not set</span>}
              </dd>
              <dt>Region</dt>
              <dd>{tenant.region || "—"}</dd>
            </dl>
          </Panel>
        )}

        <div style={{ gridColumn: impersonating ? "1 / -1" : undefined }}>
          <ImpersonationPanel tenant={tenant} impersonating={impersonating} onImpersonate={onImpersonate} onExit={onExit} />
        </div>
      </div>
    </>
  );
}
